module.exports = __webpack_public_path__ + "static/media/couple.f4d06f68.jpg";